<template>
  <o-card v-if="workshop" :title="$t('medtastic.thank_you')">
    {{ $t('medtastic.thank_you_text') }}

    <div v-if="workshop" class="upcoming-events mt-3">
      <b class="workshop-title">{{ workshop.title }}</b>

      <div class="row">
        <div class="col-12" :class="{ 'col-md-4': workshop.credits, 'col-md-6': !workshop.credits }">
          <div class="mt-4 d-flex">
            <div class="icon-calendar"><img src="/images/calendar.svg"/></div>
            <div class="calendar-text">
              {{ workshop.date|formatDay }} {{ workshop.date|formatDate }},
              <br class="d-block d-sm-none">
              {{ workshop.time|formatTimeString }}-{{ workshop.end_time|formatTimeString }}
              <template v-if="workshop.with_apero"><br> {{ $t("medtastic.apero_text")}}  </template>
            </div>
          </div>
        </div>
        <div class="col-12" :class="{ 'col-md-4': workshop.credits, 'col-md-6': !workshop.credits }">
          <div class="mt-4 d-flex">
            <div class="icon-location"><img src="/images/location.svg"/></div>
            <div class="location-text"><span v-html="workshop.location"></span>, {{ workshop.region }}</div>
          </div>
        </div>
        <div class="col-12" v-if="workshop.credits" :class="{ 'col-md-4': workshop.credits, 'col-md-6': !workshop.credits }">
          <div class="mt-4 d-flex">
            <div class="icon-location"><img src="/images/credits.svg"/></div>
            <div class="location-text">{{ workshop.credits }}</div>
          </div>
        </div>
      </div>
    </div>

    <p class="mt-3" v-if="workshop.email_comment != ''" v-html="workshop.email_comment"></p>

    <p>{{ $t('medtastic.email_registration_text') }}</p>

    <router-link class="btn btn-primary btn-back" to="/">
      {{ $t('medtastic.back_to_home') }}
    </router-link>
  </o-card>
  <o-card v-else :shadow="false" :title="$t('core.page_not_found')">
    <router-link class="btn btn-primary btn-back" to="/">
      {{ $t('medtastic.back_to_home') }}
    </router-link>
  </o-card>

</template>

<script>
import axios from 'axios'

export default {
  layout: 'user',
  data () {
    return {
      workshop: []
    }
  },
  mounted () {
    this.workshopDetail()
  },
  methods: {
    workshopDetail: function () {
      axios.get('/api/medtastic/workshops/public', { params: { 'filter[id]': this.$route.params.id } })
        .then((response) => {
          this.workshop = response.data.data[0]
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }
}
</script>
